// extracted by mini-css-extract-plugin
export default {"blue":"accents_blue__oY8O6","pink":"accents_pink__WQIXE","green":"accents_green__gMDk2","amber":"accents_amber__abDvP","purple":"accents_purple__Oe1XB","teal":"accents_teal__E3Q2i"};